import api from './api'
import type { PageAccess, UserRole } from '@/utils/pagePermissions'

export interface PermissionPage {
  key: string
  label: string
  section: string
}

export interface PermissionOverride {
  user_id: number
  email: string
  role: UserRole
  page_key: string
  access: PageAccess
  inherited_access: PageAccess
}

export interface PermissionsResponse {
  pages: PermissionPage[]
  roles: UserRole[]
  matrix: Record<UserRole, Record<string, PageAccess>>
  overrides: PermissionOverride[]
}

export interface PermissionUpdate {
  role: UserRole
  page_key: string
  access: PageAccess
}

export async function getPermissions(): Promise<PermissionsResponse> {
  const response = await api.get<PermissionsResponse>('/permissions')
  return response.data
}

export async function updatePermissions(
  updates: PermissionUpdate[],
): Promise<PermissionsResponse> {
  const response = await api.put<PermissionsResponse>('/permissions', { updates })
  return response.data
}

export async function updatePermissionOverrides(
  updates: { user_id: number; page_key: string; access: PageAccess }[],
): Promise<PermissionsResponse> {
  const response = await api.put<PermissionsResponse>('/permissions/overrides', { updates })
  return response.data
}

export async function deletePermissionOverride(
  userId: number,
  pageKey: string,
): Promise<PermissionsResponse> {
  const response = await api.delete<PermissionsResponse>(
    `/permissions/overrides/${userId}/${pageKey}`,
  )
  return response.data
}
